import React from 'react'
import { mdx } from '@mdx-js/react'
/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';


const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const MDXCodeBlock = makeShortcode("MDXCodeBlock");
const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <MDXCodeBlock title="Generating a Link token" mdxType="MDXCodeBlock">
      <pre><code parentName="pre" {...{
          "className": "language-bash"
        }}>{`curl -X POST https://production.plaid.com/link/token/create \\
-H 'Content-Type: application/json' \\
-d '{
  "client_id": <ClientQD>"\${PLAID_CLIENT_ID}"</ClientQD>,
  "secret": <SecretQD>"\${PLAID_SECRET}"</SecretQD>,
  "client_name": "Plaid Test App",
  "user": { "client_user_id": "\${UNIQUE_USER_ID}" },
  "products": ["transactions"],
  "country_codes": ["US"],
  "language": "en",
  "webhook": "https://sample.webhook.com",
  "redirect_uri": "https://example.com/callback"
}'
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go"
        }}>{`user := plaid.LinkTokenCreateRequestUser{
    ClientUserId: "USER_ID_FROM_YOUR_DB",
}
request := plaid.NewLinkTokenCreateRequest(
  "Plaid Test",
  "en",
  []plaid.CountryCode{plaid.COUNTRYCODE_US},
)
request.SetUser(user)
request.SetProducts([]plaid.Products{plaid.PRODUCTS_TRANSACTIONS})
request.SetLinkCustomizationName("default")
request.SetWebhook("https://webhook-uri.com")
request.SetRedirectUri("https://example.com/callback")
resp, _, err := testClient.PlaidApi.LinkTokenCreate(ctx).LinkTokenCreateRequest(*request).Execute()

linkToken := resp.GetLinkToken()
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-go",
          "metastring": "sdk=fern",
          "sdk": "fern"
        }}>{`user := plaid.LinkTokenCreateRequestUser{ClientUserID: "USER_ID_FROM_YOUR_DB"}
request := &plaid.LinkTokenCreateRequest{
    ClientName:   "Plaid Test",
    Language:     "en",
    CountryCodes: []plaid.CountryCode{plaid.CountryCodeUs},
}
request.User = &user
request.Products = []plaid.Products{plaid.ProductsTransactions}
request.LinkCustomizationName = plaid.String("default")
request.Webhook = plaid.String("https://webhook-uri.com")
request.RedirectURI = plaid.String("https://example.com/callback")
resp, err := client.Link.CreateToken(ctx, request)

linkToken := resp.GetLinkToken()
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-node"
        }}>{`const request = {
  user: {
    // This should correspond to a unique id for the current user.
    client_user_id: 'user-id',
  },
  client_name: 'Plaid Test App',
  products: [Products.Transactions],
  country_codes: [CountryCode.Us],
  language: 'en',
  webhook: 'https://sample-web-hook.com',
  redirect_uri: 'https://example.com/callback',
};

try {
  const createTokenResponse = await client.linkTokenCreate(request);
  const linkToken = createTokenResponse.data.link_token;
} catch (error) {
  // handle error
}
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-python"
        }}>{`user = User.find(...)
client_user_id = user.id

# Create a link_token for the given user
request = LinkTokenCreateRequest(
        products=[Products('transactions')],
        client_name="Plaid Test App",
        country_codes=[CountryCode('US')],
        redirect_uri='https://example.com/callback',
        language='en',
        webhook='https://webhook.sample.com',
        user=LinkTokenCreateRequestUser(
            client_user_id=client_user_id
        )
    )
response = client.link_token_create(request)
link_token = response['link_token']
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-ruby"
        }}>{`link_token_create_request = Plaid::LinkTokenCreateRequest.new(
    {
      user: { client_user_id: 'user-id' },
      client_name: 'Plaid Test App',
      products: ['transactions'],
      country_codes: ['US'],
      language: "en",
      redirect_uri: 'https://example.com/callback',
      webhook: 'https://webhook.sample.com'
    }
  )
  response = client.link_token_create(link_token_create_request)
`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-java"
        }}>{`User userFromDB = db.find(...);
String clientUserId = userFromDB.id;
LinkTokenCreateRequestUser user = new LinkTokenCreateRequestUser()
  .clientUserId(clientUserId);

// Create a link_token for the given user
LinkTokenCreateRequest request = new LinkTokenCreateRequest()
  .user(user)
  .clientName("Plaid Test App")
  .products(Arrays.asList(Products.TRANSACTIONS))
  .countryCodes(Arrays.asList(CountryCode.US, CountryCode.CA))
  .language("en")
  .redirectUri("https://example.com/callback")
  .webhook("https://sample.webhook.com");

Response<LinkTokenCreateResponse> response = plaidClient
  .linkTokenCreate(request)
  .execute();

String linkToken = response.body().getLinkToken();
`}</code></pre>
    </MDXCodeBlock>
  
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
